import { ChangeEvent, Dispatch, SetStateAction } from "react";

import { Col, Row } from "react-bootstrap";

import { ReferentialType } from "../../../_constants/referentialType";
import { RequiredInput } from "../../../common/components/FormError.tsx";
import SelectCreatable from "../../../common/components/SelectCreatable.tsx";
import { IReferentials } from "../../referential/reducers";
import { IDwelling } from "../reducers";

export interface DwellingFormAdditionalProps {
  dwelling: IDwelling;
  setDwelling: Dispatch<SetStateAction<IDwelling>>;
  referentials: IReferentials;
}

const DwellingAdditionalForm = ({
  dwelling,
  setDwelling,
  referentials,
}: DwellingFormAdditionalProps) => {
  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = event.currentTarget;
    console.log(name, value);
    updateDwelling(name, value);
  };
  const updateDwelling = (dwellingField: string, value: any) => {
    setDwelling({
      ...dwelling,
      [dwellingField]: value,
    });
  };

  return (
    <>
      <Row className="mt-1">
        <Col xs={12}>
          <label className="w-100 add-prop-label ms-2">
            État du bien : <RequiredInput />
          </label>
          <div className="select-creatable-team-member-form">
            <SelectCreatable
              options={referentials[ReferentialType.DWELLING_CONDITION].data}
              getValue={(value) => updateDwelling("condition", value)}
              isMulti={false}
              creatable={true}
              defaultValue={dwelling.condition}
            />
          </div>
        </Col>
      </Row>

      <Row className="mt-1">
        <Col
          xs={12}
          className="mt-3 d-flex justify-content-between flex-column"
        >
          <label className="w-100 add-prop-label ms-2">
            Lien de la visite virtuelle 360 :
          </label>
          <input
            className="w-100 add-prop-input"
            type="text"
            placeholder={"https://..."}
            name="linkVirtualVisit"
            value={dwelling.linkVirtualVisit}
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col xs={12}>
          <label className="w-100 add-prop-label ms-2">Commentaires :</label>
          <textarea
            className="w-100 add-prop-input add-prop-textarea"
            placeholder="Cuisine neuve, peinture neuve, etc..."
            name="comment"
            value={dwelling.comment}
            onChange={handleChange}
          />
        </Col>
      </Row>
    </>
  );
};
export default DwellingAdditionalForm;
